export default __webpack_public_path__ + "static/media/trr-drink-coffee-americano.4e6c392d.png";